if(!customElements.get("expandable-text")) {
  class ExpandableText extends HTMLElement {
    constructor() {
      super();
      this.isExpanded = false;
      this.toggleButton = this.querySelector('[toggle-button]');
      this.textOnOpen = this.toggleButton.dataset.textOnOpen || 'Continue reading';
      this.textOnClose = this.toggleButton.dataset.textOnClose || 'Show less';
    }

    connectedCallback() {
      this.toggleButton.addEventListener('click', () => this.toggleText());
    }

    toggleText() {
      if (!this.isExpanded) {
        this.classList.add('expanded');
        this.toggleButton.textContent = this.textOnClose;
      } else {
        this.classList.remove('expanded');
        this.toggleButton.textContent = this.textOnOpen;
      }
      this.isExpanded = !this.isExpanded;
    }
  }
  customElements.define('expandable-text', ExpandableText);
}